import { render, staticRenderFns } from "./event_search_result.vue?vue&type=template&id=76629b20&"
import script from "./event_search_result.vue?vue&type=script&lang=js&"
export * from "./event_search_result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports